<div *ngIf="showProgress" class="progress-bar" id="progress-bar">
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
</div>
